/* Skincare Assessment — port of the WooCommerce skincare-quiz plugin.
   Questions from class-quiz.php; scoring, routine steps and budget
   enforcement from class-recommendation-engine.php. */
(function () {
  'use strict';

  var root = document.getElementById('skq');
  if (!root) return;

  // ---------------------------------------------------------------- questions
  var QUESTIONS = [
    { id: 'skin_type', type: 'single', q: 'How would you describe your skin type?', a: {
      oily: 'Oily', dry: 'Dry', combination: 'Combination',
      normal: 'Normal', sensitive: 'Sensitive', not_sure: 'Not sure' } },
    { id: 'primary_concern', type: 'single', q: 'What is your main skin concern?', a: {
      acne: 'Acne & Breakouts', dark_spots: 'Dark Spots', hyperpigmentation: 'Hyperpigmentation',
      redness: 'Redness', sensitivity: 'Sensitivity', dryness: 'Dryness', dehydration: 'Dehydration',
      large_pores: 'Large Pores', fine_lines: 'Fine Lines', dullness: 'Dullness',
      uneven_texture: 'Uneven Texture', eye_puffiness: 'Eye Puffiness' } },
    { id: 'secondary_concern', type: 'single', q: 'What is your second biggest concern?', a: {
      acne: 'Acne & Breakouts', dark_spots: 'Dark Spots', hyperpigmentation: 'Hyperpigmentation',
      redness: 'Redness', sensitivity: 'Sensitivity', dryness: 'Dryness', dehydration: 'Dehydration',
      large_pores: 'Large Pores', fine_lines: 'Fine Lines', dullness: 'Dullness',
      uneven_texture: 'Uneven Texture', eye_puffiness: 'Eye Puffiness' } },
    { id: 'sensitivity', type: 'single', q: 'Does your skin get irritated easily?', a: {
      very_often: 'Very often', sometimes: 'Sometimes', rarely: 'Rarely',
      never: 'Never', not_sure: 'Not sure' } },
    { id: 'current_routine', type: 'multiple', q: 'What products do you currently use?', a: {
      cleanser: 'Cleanser', toner: 'Toner', serum: 'Serum', moisturizer: 'Moisturizer',
      sunscreen: 'Sunscreen', exfoliator: 'Exfoliator', retinol: 'Retinol',
      mask: 'Face Mask', eye_care: 'Eye Cream', none: 'None currently' } },
    { id: 'sun_exposure', type: 'single', q: 'How much time do you spend in the sun daily?', a: {
      less_1: 'Less than 1 hour', '1_3': '1–3 hours', '3_5': '3–5 hours', more_5: 'More than 5 hours' } },
    { id: 'routine_commitment', type: 'single', q: 'How many skincare steps can you realistically commit to?', a: {
      '3_step': '3-step routine', '5_step': '5-step routine', full: 'Full routine' } },
    { id: 'budget', type: 'single', q: 'What is your ideal budget for your skincare routine?', a: {
      budget_3000: 'Under 3,000 EGP', budget_5000: '3,000 – 5,000 EGP',
      budget_8000: '5,000 – 8,000 EGP', premium: 'Above 8,000 EGP' } },
    { id: 'age_range', type: 'single', q: 'What is your age range?', a: {
      under_18: 'Under 18', '18_24': '18–24', '25_34': '25–34', '35_44': '35–44', '45_plus': '45+' } }
  ];

  var TOTAL = QUESTIONS.length + 1;               // + the contact step

  var ROUTINES = {
    '3_step': { am: ['cleanser', 'moisturizer', 'sunscreen'],
                pm: ['cleanser', 'serum', 'moisturizer'] },
    '5_step': { am: ['cleanser', 'toner', 'serum', 'moisturizer', 'sunscreen'],
                pm: ['cleanser', 'toner', 'serum', 'moisturizer', 'eye_care'] },
    full:     { am: ['cleanser', 'toner', 'serum', 'moisturizer', 'sunscreen', 'eye_care'],
                pm: ['cleanser', 'toner', 'serum', 'moisturizer', 'retinol', 'eye_care'] }
  };

  var BUDGET_MAX = { budget_3000: 3000, budget_5000: 5000, budget_8000: 8000, premium: 0 };

  var STEP_LABEL = {
    cleanser: 'Cleanser', toner: 'Toner', serum: 'Serum', moisturizer: 'Moisturizer',
    sunscreen: 'Sunscreen', eye_care: 'Eye Care', retinol: 'Retinol',
    exfoliator: 'Exfoliator', mask: 'Mask'
  };

  var SKIN_SUMMARY = {
    oily: 'Your skin produces excess sebum, especially through the T-zone. Lightweight, non-comedogenic layers keep shine down without triggering more oil.',
    dry: 'Your skin lacks natural oils and can feel tight. Richer creams and humectants help rebuild the barrier and hold on to moisture.',
    combination: 'You have an oily T-zone with drier cheeks. Balanced, targeted layers let you treat both zones without over-correcting either.',
    normal: 'Your skin is well balanced. A consistent routine focused on protection and maintenance will keep it that way.',
    sensitive: 'Your skin reacts easily to new products. Gentle, fragrance-free formulas introduced one at a time are the safest route.',
    not_sure: "We've built a balanced routine that suits most skin types — a good place to start while you learn how your skin responds."
  };

  var CONCERN_LABEL = QUESTIONS[1].a;

  // ---------------------------------------------------------------- state
  var answers = {};
  var contact = {};
  var step = 0;                                   // 0..QUESTIONS.length (last = contact)
  var catalogue = null;

  var screens = document.getElementById('skq-screens');
  var nextBtn = document.getElementById('skq-next');
  var backBtn = document.getElementById('skq-back');
  var countEl = document.getElementById('skq-count');
  var barEl = document.getElementById('skq-progress');
  var form = document.getElementById('skq-form');
  var loadingEl = document.getElementById('skq-loading');
  var resultsEl = document.getElementById('skq-results');
  var headEl = document.getElementById('skq-head');
  var contactStep = document.getElementById('skq-contact-step');
  var customerForm = document.getElementById('skq-customer-form');
  var submitBtn = document.getElementById('skq-submit');
  var STORE_KEY = 'skq-state';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(n) {
    return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'EGP';
  }

  // ---------------------------------------------------------------- rendering
  function render() {
    var isContact = step === QUESTIONS.length;
    countEl.textContent = step + ' / ' + TOTAL;
    barEl.style.width = (step / TOTAL * 100) + '%';
    backBtn.hidden = step === 0;

    if (isContact) {
      form.hidden = true;
      contactStep.hidden = false;
      bindContact();
      validateContact();
      return;
    }
    form.hidden = false;
    contactStep.hidden = true;

    var q = QUESTIONS[step];
    var picked = answers[q.id];
    var opts = Object.keys(q.a).map(function (val) {
      var on = q.type === 'multiple'
        ? (picked || []).indexOf(val) !== -1
        : picked === val;
      return '<label class="skq__opt' + (on ? ' is-on' : '') + '">' +
        '<input type="' + (q.type === 'multiple' ? 'checkbox' : 'radio') + '" name="' + q.id + '" value="' + esc(val) + '"' + (on ? ' checked' : '') + '>' +
        '<span class="skq__mark"></span><span>' + esc(q.a[val]) + '</span></label>';
    }).join('');

    screens.innerHTML =
      '<div class="skq__screen">' +
        '<span class="skq__label">Question ' + (step + 1) + ' of ' + TOTAL + '</span>' +
        '<h3 class="skq__q">' + esc(q.q) + '</h3>' +
        '<div class="skq__opts">' + opts + '</div>' +
      '</div>';
    nextBtn.textContent = 'Continue';
    bindOptions(q);
    validate(q);
  }

  function bindOptions(q) {
    screens.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (q.type === 'multiple') {
          var vals = Array.prototype.slice
            .call(screens.querySelectorAll('input:checked'))
            .map(function (i) { return i.value; });
          answers[q.id] = vals;
        } else {
          answers[q.id] = input.value;
        }
        screens.querySelectorAll('.skq__opt').forEach(function (l) {
          l.classList.toggle('is-on', l.querySelector('input').checked);
        });
        validate(q);
      });
    });
  }

  function bindContact() {
    if (contactStep.dataset.bound) return;
    contactStep.dataset.bound = '1';
    ['skq_first', 'skq_phone', 'skq_email'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', validateContact);
    });
  }

  function validate(q) {
    var v = answers[q.id];
    nextBtn.disabled = q.type === 'multiple' ? !(v && v.length) : !v;
  }

  function readContact() {
    contact.full_name = (document.getElementById('skq_first') || {}).value || '';
    contact.phone = (document.getElementById('skq_phone') || {}).value || '';
    contact.email = (document.getElementById('skq_email') || {}).value || '';
    contact.full_name = contact.full_name.trim();
  }

  function validateContact() {
    readContact();
    var ok = contact.full_name.length > 1 &&
             /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(contact.email) &&
             contact.phone.replace(/\D/g, '').length >= 10;
    if (submitBtn) submitBtn.disabled = !ok;
  }

  // ---------------------------------------------------------------- engine
  function scoreProduct(p, isSensitive, usedBrands) {
    var s = 0;
    if (p.skin.length && p.skin.indexOf(answers.skin_type) !== -1) s += 30;
    if (p.con.length && p.con.indexOf(answers.primary_concern) !== -1) s += 25;
    if (p.con.length && p.con.indexOf(answers.secondary_concern) !== -1) s += 15;
    if (isSensitive && !p.sens) s -= 50; else s += 10;
    if (p.age.length && p.age.indexOf(answers.age_range) !== -1) s += 5;
    if (p.b) {
      for (var i = 0; i < usedBrands.length; i++) {
        if (String(usedBrands[i]).toLowerCase() === String(p.b).toLowerCase()) { s += 15; break; }
      }
    }
    if (p.sun) s += 10;
    return s * (p.w || 1);
  }

  function pickBest(stepName, isSensitive, usedBrands, excludeHandle, maxPrice) {
    var best = null, bestScore = -Infinity;
    for (var i = 0; i < catalogue.length; i++) {
      var p = catalogue[i];
      if (p.step !== stepName || !p.a) continue;
      if (excludeHandle && p.h === excludeHandle) continue;
      if (maxPrice != null && p.p >= maxPrice) continue;
      var sc = scoreProduct(p, isSensitive, usedBrands);
      if (sc > bestScore) { bestScore = sc; best = p; }
    }
    return best;
  }

  function build() {
    var commitment = answers.routine_commitment || '5_step';
    var isSensitive = ['very_often', 'sometimes'].indexOf(answers.sensitivity) !== -1;
    var plan = ROUTINES[commitment] || ROUTINES['5_step'];

    var used = [], all = [], am = [], pm = [];

    ['am', 'pm'].forEach(function (time) {
      plan[time].forEach(function (stepName) {
        var p = pickBest(stepName, isSensitive, used, null, null);
        if (!p) return;
        var item = Object.assign({}, p, { time: time });
        (time === 'am' ? am : pm).push(item);
        all.push(item);
        if (p.b) used.push(p.b);
      });
    });

    // budget enforcement — repeatedly swap in the biggest available saving
    var max = BUDGET_MAX[answers.budget] || 0;
    if (max > 0) {
      var total = all.reduce(function (t, p) { return t + p.p; }, 0);
      var guard = 0;
      while (total > max && guard < 30) {
        var bestIdx = -1, bestRepl = null, bestSaving = 0;
        for (var i = 0; i < all.length; i++) {
          var cur = all[i];
          var cheaper = pickBest(cur.step, isSensitive, used, cur.h, cur.p);
          if (!cheaper) continue;
          var saving = cur.p - cheaper.p;
          if (saving > bestSaving) { bestSaving = saving; bestIdx = i; bestRepl = cheaper; }
        }
        if (bestIdx === -1) break;
        var old = all[bestIdx];
        var repl = Object.assign({}, bestRepl, { time: old.time });
        all[bestIdx] = repl;
        var list = old.time === 'am' ? am : pm;
        for (var j = 0; j < list.length; j++) {
          if (list[j].step === old.step) { list[j] = repl; break; }
        }
        total -= bestSaving;
        guard++;
      }
    }

    var price = all.reduce(function (t, p) { return t + p.p; }, 0);
    var worth = all.reduce(function (t, p) { return t + (p.c || p.p); }, 0);
    return { am: am, pm: pm, all: all, price: price, worth: worth, savings: Math.max(0, worth - price) };
  }

  // ---------------------------------------------------------------- results
  function card(p) {
    return '<a class="skq__card" href="/products/' + esc(p.h) + '">' +
      '<span class="skq__card-step">' + esc(STEP_LABEL[p.step] || p.step) + '</span>' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy">'
           : '<span class="skq__card-ph"></span>') +
      '<span class="skq__card-body">' +
        (p.b ? '<span class="skq__card-brand">' + esc(p.b) + '</span>' : '') +
        '<span class="skq__card-name">' + esc(p.t) + '</span>' +
        '<span class="skq__card-price">' +
          (p.c && p.c > p.p ? '<del>' + money(p.c) + '</del> ' : '') + money(p.p) +
        '</span>' +
      '</span></a>';
  }

  function routineBlock(title, dot, items) {
    if (!items.length) return '';
    return '<div class="skq__routine">' +
      '<h4><span class="skq__dot skq__dot--' + dot + '"></span>' + title + '</h4>' +
      '<div class="skq__cards">' + items.map(card).join('') + '</div></div>';
  }

  function showResults(res) {
    var concerns = [answers.primary_concern, answers.secondary_concern]
      .filter(Boolean)
      .map(function (c) { return '<span class="skq__tag">' + esc(CONCERN_LABEL[c] || c) + '</span>'; })
      .join('');

    resultsEl.innerHTML =
      '<div class="skq__res">' +
        '<h3 class="skq__res-title">' + esc(contact.full_name.split(' ')[0]) + ', here is your routine</h3>' +
        '<div class="skq__block"><span class="skq__block-label">Your skin</span>' +
          '<p>' + esc(SKIN_SUMMARY[answers.skin_type] || SKIN_SUMMARY.not_sure) + '</p>' +
          '<div class="skq__tags">' + concerns + '</div></div>' +
        routineBlock('Morning routine', 'am', res.am) +
        routineBlock('Evening routine', 'pm', res.pm) +
        '<div class="skq__bundle">' +
          '<div><span class="skq__bundle-label">Your full routine</span>' +
            '<span class="skq__bundle-total">' + money(res.price) + '</span>' +
            (res.savings > 0 ? '<span class="skq__bundle-worth">Worth ' + money(res.worth) +
              ' &middot; you save ' + money(res.savings) + '</span>' : '') +
          '</div>' +
          '<button type="button" class="skq__add" id="skq-add">Add routine to bag</button>' +
        '</div>' +
        '<p class="skq__disclaimer">These recommendations are generated from your answers and are not medical advice. ' +
        'Introduce new actives one at a time, and patch-test if your skin is reactive.</p>' +
      '</div>';

    resultsEl.hidden = false;
    document.getElementById('skq-add').addEventListener('click', function () {
      addToCart(res.all, this);
    });
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function addToCart(items, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (p) { return { id: p.vid, quantity: 1 }; }) })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        // fall back to per-item form posts if variant ids are unavailable
        window.location.href = '/products/' + items[0].h;
      });
  }

  // ---------------------------------------------------------------- lead save
  // Shopify rejects scripted POSTs to /contact (403 spam protection), so the
  // customer form is submitted natively. Shopify redirects back here with
  // ?customer_posted=true and the results are rebuilt from sessionStorage.
  function buildTags() {
    var tags = ['skincare-quiz'];
    ['skin_type', 'primary_concern', 'secondary_concern', 'sensitivity',
     'sun_exposure', 'routine_commitment', 'budget', 'age_range'].forEach(function (k) {
      if (answers[k]) tags.push(k.replace(/_/g, '-') + ':' + answers[k]);
    });
    if (contact.phone) tags.push('phone:' + contact.phone.replace(/\s/g, ''));
    return tags.join(',');
  }

  // Primary store: the Skinoria app. Keeps the full submission plus the
  // recommended routine, and mirrors the lead into Shopify as a tagged customer.
  function saveToApp(res) {
    var api = (root.dataset.api || '').replace(/\/+$/, '');
    if (!api) return;
    var recommended = (res && res.all ? res.all : []).map(function (p) {
      return { handle: p.h, title: p.t, step: p.step, price: p.p };
    });
    try {
      fetch(api + '/api/quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          answers: answers,
          contact: contact,
          recommended: recommended,
          total_price: res ? res.price : 0
        })
      }).catch(function () {});
    } catch (e) { /* never block the results */ }
  }

  // A second copy of the answers rides on the cart, so they land on the order.
  function saveToCart() {
    var attrs = {
      'Skincare quiz': 'yes',
      'Quiz name': contact.full_name || '',
      'Quiz phone': contact.phone || '',
      'Quiz email': contact.email || ''
    };
    QUESTIONS.forEach(function (q) {
      var v = answers[q.id];
      if (Array.isArray(v)) v = v.map(function (x) { return q.a[x] || x; }).join(', ');
      else v = q.a[v] || v || '';
      if (v) attrs['Quiz ' + q.id.replace(/_/g, ' ')] = v;
    });
    try {
      navigator.sendBeacon('/cart/update.js', new Blob(
        [JSON.stringify({ attributes: attrs })], { type: 'application/json' }));
    } catch (e) { /* best-effort */ }
  }

  // ---------------------------------------------------------------- flow
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (nextBtn.disabled) return;
    step++;
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (customerForm) {
    customerForm.addEventListener('submit', function () {
      readContact();
      var names = contact.full_name.split(/\s+/);
      document.getElementById('skq_first').value = names.shift() || '';
      document.getElementById('skq_last').value = names.join(' ');
      document.getElementById('skq_tags').value = buildTags();
      saveToCart();
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          answers: answers, contact: contact, at: Date.now()
        }));
      } catch (e) { /* private mode — results just won't persist */ }
      // The signup sits behind Shopify's captcha. If the page hasn't navigated
      // shortly after submit, show the routine anyway — the shopper should never
      // lose their result because spam protection stalled.
      setTimeout(function () {
        if (!document.hidden && resultsEl.hidden) showLoadingThenResults();
      }, 4000);
      // let the browser submit natively
    });
  }

  backBtn.addEventListener('click', function () {
    if (step > 0) { step--; render(); }
  });
  var back2 = document.getElementById('skq-back2');
  if (back2) back2.addEventListener('click', function () { step--; render(); });

  function showLoadingThenResults() {
    form.hidden = true;
    contactStep.hidden = true;
    headEl.hidden = true;
    loadingEl.hidden = false;
    countEl.textContent = TOTAL + ' / ' + TOTAL;
    barEl.style.width = '100%';
    loadCatalogue().then(function () {
      loadingEl.hidden = true;
      var res = build();
      saveToApp(res);
      showResults(res);
    }).catch(function () {
      loadingEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.innerHTML = '<div class="skq__res"><p>Sorry — we could not build your routine just now. ' +
        'Your details were saved and we will follow up.</p></div>';
    });
  }

  // After the customer form posts, Shopify reloads this page. Restore from the
  // snapshot taken at submit time so the shopper always gets their routine —
  // whether or not the signup itself succeeded (it sits behind a captcha).
  function restore() {
    var raw;
    try { raw = sessionStorage.getItem(STORE_KEY); } catch (e) { return false; }
    if (!raw) return false;
    var st;
    try { st = JSON.parse(raw); } catch (e) { return false; }
    if (!st || !st.answers || !st.answers.routine_commitment) return false;
    if (Date.now() - (st.at || 0) > 10 * 60 * 1000) {   // stale — start fresh
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
      return false;
    }
    answers = st.answers;
    contact = st.contact || {};
    showLoadingThenResults();
    return true;
  }

  function loadCatalogue() {
    if (catalogue) return Promise.resolve();
    return fetch(root.dataset.catalogue)
      .then(function (r) { return r.json(); })
      .then(function (d) { catalogue = d.products || []; });
  }

  // warm the catalogue up in the background while the user answers
  loadCatalogue().catch(function () {});
  if (!restore()) render();
})();
